import {css} from "@emotion/react";

export const root = css`
    display: flex;
    height: 62px;
    padding: 16px;
    background-color: white;
`;